import { IAccount } from "@wingspanhq/users/dist/lib/interfaces";
import { selectorAccountRtpReady } from "../../modules/Transfer/components/FormTransfer/selectorAccountRtpReady";
import { selectorAccountInternationalIPReady } from "./selectorAccountInternationalIPReady";

export const selectorAccountIPReady = (
  account: IAccount,
  isInternationalUser: boolean
) =>
  (!isInternationalUser && selectorAccountRtpReady(account)) ||
  selectorAccountInternationalIPReady(account);
